function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.843 35.853v8.578M6.686 59.873H4.971a3.432 3.432 0 01-3.432-3.432v-27.45a3.431 3.431 0 013.432-3.432h37.745a3.43 3.43 0 013.431 3.431v15.441"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.284 25.559V16.98c0-8.528-6.913-15.44-15.44-15.44-8.529 0-15.442 6.912-15.442 15.44v8.579m6.863 27.451h65.196v27.451H15.265zm8.578 8.578l10.294 10.294m0-10.294L23.843 71.882m18.873-10.294L53.01 71.882m0-10.294L42.716 71.882m17.157 1.716h13.725M23.843 34.995a.858.858 0 110 1.716.858.858 0 010-1.716"
}));

function SvgResetPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82
  }, props), _ref);
}

export default SvgResetPassword;